import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CronJobName } from '../CronJobsCRUDForm.types';

import { JobNameSelect } from '../JobNameSelect';

import { AutoSendToFlexBlockSection } from './AutoSendToFlexBlockSection';
import { SyncEmployeeRoutesSection } from './SyncEmployeeRoutesSection';

interface Props {
  selectedJobType: CronJobName;
  changeJobType: React.Dispatch<React.SetStateAction<CronJobName>>;
}

export const SynchronisationCronJobsFormContent: React.FC<Props> = ({
  selectedJobType,
  changeJobType
}) => {
  const { t } = useTranslation();
  const { setValue, reset } = useFormContext();

  // None of these three is installation-wide today, but sync-employee-routes becomes so when its
  // own tenant field is left on "Alle tenants" - so the labels come from the API's scopes rather
  // than from a list kept here.
  const jobNames: CronJobName[] = [
    'export-employee-hours',
    'auto-send-to-flex',
    'sync-employee-routes'
  ];

  return (
    <>
      <JobNameSelect
        jobNames={jobNames}
        label={t('cronJobs.grid.jobName')}
        selectedJobType={selectedJobType}
        onSelected={(value) => {
          changeJobType(value);
          setValue('jobName', value);
          reset();
        }}
      />
      {selectedJobType === 'auto-send-to-flex' ? (
        <AutoSendToFlexBlockSection />
      ) : selectedJobType === 'sync-employee-routes' ? (
        <SyncEmployeeRoutesSection />
      ) : (
        <></>
      )}
    </>
  );
};
